import './password-guidelines.scss';
import en from '../../lang/en-us';
const { passwordGuidelines } = en;

export const MINIMUM_EIGHT_CHARCTERS_REGEX = 8;
export const UPPER_CASE_LOWER_CASE = new RegExp('(?=.*[a-z])(?=.*[A-Z])');
export const ONE_SPECIAL_CHARACTER = new RegExp('(?=.*[!@#$%^&*?><_])[A-Za-zd!@#$%^&*?><_]');
export const WHITESPACE = /\s/g;

export function PasswordGuidelines(props: any) {
    const { value: password } = props;
    const length = password.length >= MINIMUM_EIGHT_CHARCTERS_REGEX && !WHITESPACE.test(password);
    const upperAndLowerCase = UPPER_CASE_LOWER_CASE.test(password);
    const specialChar = ONE_SPECIAL_CHARACTER.test(password);
    return (
        <div className="password_guidelines">
            <p>
                <img
                    src={length ? '/images/tick-green.svg ' : '/images/small-tick.svg'}
                    alt="icon"
                />
                {passwordGuidelines.one}
            </p>
            <p>
                <img
                    src={upperAndLowerCase ? '/images/tick-green.svg ' : '/images/small-tick.svg'}
                    alt="icon"
                />
                {passwordGuidelines.two}
            </p>
            <p>
                <img
                    src={specialChar ? '/images/tick-green.svg ' : '/images/small-tick.svg'}
                    alt="icon"
                />
                {passwordGuidelines.three} &nbsp;
                <span>{'(!,@,#,$,%,^,&,*,?,>,<,_)'}</span>
            </p>
        </div>
    );
}
